import Swal from 'sweetalert2';

/**
 * SweetAlert2 utility functions for consistent alerts across the application
 */

// Confirmation dialog for delete actions
export const confirmDelete = async (itemName, itemType = 'item') => {
  const result = await Swal.fire({
    title: `Delete ${itemType}?`,
    html: `Are you sure you want to delete <strong>${itemName}</strong>?<br><small>This action cannot be undone.</small>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
    focusCancel: true,
  });

  return result.isConfirmed;
};

// Confirmation dialog for unfreeze actions
export const confirmUnfreeze = async (itemName) => {
  const result = await Swal.fire({
    title: 'Unfreeze Membership?',
    html: `Are you sure you want to unfreeze <strong>${itemName}'s</strong> membership?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#2563eb',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Yes, unfreeze it',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
  });

  return result.isConfirmed;
};

// Generic confirmation dialog
export const confirmAction = async (title, message, confirmText = 'Yes', cancelText = 'Cancel') => {
  const result = await Swal.fire({
    title,
    text: message,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#2563eb',
    cancelButtonColor: '#6b7280',
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
  });

  return result.isConfirmed;
};

// Success alert
export const showSuccess = (title, message) => {
  return Swal.fire({
    icon: 'success',
    title,
    text: message,
    confirmButtonColor: '#2563eb',
    timer: 2000,
    showConfirmButton: false,
  });
};

// Error alert
export const showError = (title, message) => {
  return Swal.fire({
    icon: 'error',
    title,
    text: message,
    confirmButtonColor: '#dc2626',
  });
};

// Warning alert
export const showWarning = (title, message) => {
  return Swal.fire({
    icon: 'warning',
    title,
    text: message,
    confirmButtonColor: '#f59e0b',
  });
};

// Info alert
export const showInfo = (title, message) => {
  return Swal.fire({
    icon: 'info',
    title,
    text: message,
    confirmButtonColor: '#2563eb',
  });
};

// Loading alert
export const showLoading = (title = 'Please wait...', message = 'Processing your request') => {
  Swal.fire({
    title,
    text: message,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

// Close any open alert
export const closeAlert = () => {
  Swal.close();
};

// Show error for member with active membership
export const showActiveMembershipError = async () => {
  const result = await Swal.fire({
    icon: 'error',
    title: 'Cannot Delete Member',
    html: `
      <p>This member has an active membership plan.</p>
      <p class="mt-2"><strong>To delete this member:</strong></p>
      <ol class="text-left mt-2 ml-6">
        <li>Cancel their active membership first, or</li>
        <li>Wait for the membership to expire</li>
      </ol>
    `,
    confirmButtonColor: '#dc2626',
    confirmButtonText: 'Got it',
  });
  return result;
};

export default {
  confirmDelete,
  confirmUnfreeze,
  confirmAction,
  showSuccess,
  showError,
  showWarning,
  showInfo,
  showLoading,
  closeAlert,
  showActiveMembershipError,
};
